<template>
    <section class="Block Editlog Overview">
        <ul class="block-grid one-up">
            <li>
                <label>{{ trans("Aangemaakt op") }}:</label>
                <var>{{ this.$filters.formatPostDate(viewData.item.data.data.creation_date) }}</var>
            </li>
            <li>
               <label>{{ trans("Laatst bewerkt op") }}:</label>
                <var>{{ this.$filters.formatPostDate(viewData.item.data.data.version_date) }}</var>
            </li>
            <li>
                <label>{{ trans("Laatst bewerkt door") }}:</label>
                <var>{{ viewData.item.data.data.version_user }}</var>
            </li>
        </ul>
    </section>
</template>

<script>
import {defineComponent, onMounted, onUnmounted, reactive, watch, inject} from "vue";

// Helper functions
import { getDataAsync } from "helpers/_api";
import { resolveData } from "helpers/_data";

import trans from "helpers/_translation";

// Config for API urls used in this vue template
import { config, apiHostname } from "config";

export default defineComponent({
    name: "editlog-overview",
    components: {},
    props: {
        item_id: {
            type: String,
            required: false
        },
        module_object: {
            type: String,
            required: false
        }
    },
    setup(props) {
        const viewData = inject("viewData");

        return {
            viewData,
            trans
        };
    },
});
</script>